import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { AuthService, UtilService } from "../../services";
import { PatientReg } from "app/shared/models/patient-reg.model";
import { SetPatientReg } from "../../actions/patient-reg.action";
import { Store } from "@ngrx/store";

@Component({
  selector: "app-patient-portal-register",
  templateUrl: "./patient-portal-register.html",
  styleUrls: ["./patient-portal-register.component.scss"]
})
export class PatientPortalRegisterComponent implements OnInit {
  loginInvalid: boolean = false;
  monthOfBirth: string;
  dayOfBirth: string;
  yearOfBirth: string;
  userId: number = null;

  private patientReg: PatientReg;

  constructor(
    public router: Router,
    public route: ActivatedRoute,
    private authService: AuthService,
    private store: Store<any>,
    private utilService: UtilService
  ) {}

  ngOnInit() {
    this.userId = this.route.snapshot.queryParams["userId"];
    let accessToken = this.route.snapshot.queryParams["token"];
    sessionStorage.setItem("AccessToken", accessToken);
    this.patientReg = new PatientReg();
  }

  onLogin(formValues) {
    this.loginInvalid = false;

    let dobPayload: DOBPayload = {
      userId: this.userId,
      monthOfBirth: this.utilService.leftPadDay(formValues.monthOfBirth),
      dayOfBirth: this.utilService.leftPadDay(formValues.dayOfBirth),
      yearOfBirth: formValues.yearOfBirth
    };

    this.authService
      .verifyDOB(dobPayload)
      .then((data: any) => {
        this.patientReg.DobVerified = true;
        this.patientReg.UserId = this.userId;
        // this.store.dispatch(new SetPatientReg(this.patientReg));

        sessionStorage.setItem("patientRegDobVerified", this.patientReg.DobVerified.toString());
        sessionStorage.setItem("patientRegUserId", this.patientReg.UserId.toString());

        sessionStorage.setItem("PatientUsername", data.username);
        this.router.navigate(["/patient-portal/password"]);
      })
      .catch((error: any) => {
        this.loginInvalid = true;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/login/patient-portal-register.component.ts